// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Wyślij',
    stop: 'Zatrzymaj',
    attach: 'Załącz pliki',
    add: 'Dodaj',
    upload_files: 'Prześlij pliki',
  },
  attachment: {
    uploading: 'Przesyłanie {{percent}}%',
    uploading_file: 'Przesyłanie {{name}}',
    retry: 'Ponów',
    remove: 'Usuń {{name}}',
    cancel: 'Anuluj przesyłanie {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'Oczekuje',
    running: 'W trakcie',
    done: 'Gotowe',
    failed: 'Niepowodzenie',
    denied: 'Odrzucono',
    background: 'W tle',
    summary_one: '{{count}} krok',
    summary_few: '{{count}} kroki',
    summary_many: '{{count}} kroków',
    summary_other: '{{count}} kroku',
    failed_count_one: '{{count}} nieudanych',
    failed_count_few: '{{count}} nieudane',
    failed_count_many: '{{count}} nieudanych',
    failed_count_other: '{{count}} nieudanych',
    retried_one: '{{count}} nieudany krok został ponowiony',
    retried_few: '{{count}} kroki zostały ponowione',
    retried_many: '{{count}} kroków zostało ponowionych',
    retried_other: '{{count}} nieudanych kroków zostało ponowionych',
  },
  question: {
    suggested: 'Sugerowane',
    withdrawn: 'Już niepotrzebne',
  },
  thread: {
    live_on: 'Aktywne na {{domain}}',
    unread_one: '{{count}} nowych',
    unread_few: '{{count}} nowe',
    unread_many: '{{count}} nowych',
    unread_other: '{{count}} nowych',
    working: 'W toku',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Gotowe',
    running: 'W toku',
    waiting: 'Wymaga uwagi',
    failed: 'Niepowodzenie',
    pending: 'Jeszcze nie',
    skipped: 'Pominięto',
  },
  lightbox: {
    enlarge: 'Powiększ: {{label}}',
    close: 'Zamknij',
  },
};
